import React from "react";
import PropTypes from "prop-types";

import "./InsightsView.css";

import { useEmbedInsight } from "./hooks";

export function InsightsView({ id }) {
  const { embedInsight } = useEmbedInsight(id);

  return <div className="insight" ref={embedInsight} />;
}

InsightsView.propTypes = { id: PropTypes.string.isRequired };

export default InsightsView;
